import React from "react";
import { RideSharingStateContext, } from "..";

export function useAppState() {
  return React.useContext(RideSharingStateContext);
}
